export default __webpack_public_path__ + "static/media/vayuda_turquoise_gemstone.2703ac67.png";